export const TRON_NETWORK_TYPE = 195;

export interface AddressFormat {
  regex: string;
  length: number;
}

export interface NetworkMetadata {
  id: string;
  networkType: number | null;
  code: string;
  name: string;
  symbol: string | null;
  iconKey: string | null;
  nativeCurrencyId: string | null;
  addressFormat: AddressFormat;
  sortOrder: number;
  addressFamily: number | null;
  forWalletCreation: boolean;
}

export type ChainNetworkMetadata = NetworkMetadata & { networkType: number };

export interface CurrencyMetadata {
  id: string;
  networkId: string;
  symbol: string;
  display: string;
  name: string;
  isNative: boolean;
  contractAddress: string | null;
  precision: number;
  iconKey: string | null;
  sortOrder: number;
}

export interface NetworkMetadataResponse {
  networks: NetworkMetadata[];
  currencies: CurrencyMetadata[];
}
